'use strict';

require('../../style/index.css');


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_antd@3.0.0-alpha.5@antd/lib/icon/style/css.js
// module id = 64
// module chunks = 0